import React from 'react';
import { Section, SectionHeader } from './ui/Section';
import { valueStats } from '../data/content';
import { resources } from '../data/resources';
export function IncludedSection() {
  return <Section id="incluye" tone="sand" className="py-14 sm:py-16 lg:py-20" data-id="element-74" data-mp="37fo147a8y18i">
      <SectionHeader title="¿Qué incluye Europa por Primera Vez?" intro="Una guía completa acompañada de recursos prácticos para organizar cada parte del viaje." data-id="element-75" data-mp="37hha3t8c0xjo" />

      <ul className="mx-auto mt-7 flex max-w-[46rem] flex-wrap justify-center gap-2 sm:mt-9" data-id="element-76" data-mp="3yxrzjjdb82l">
        {valueStats.map(stat => <li key={stat} className="rounded-full border border-travertino/50 bg-white px-3.5 py-1.5 font-sans text-[10.5px] font-medium uppercase tracking-[0.1em] text-oceano/80" data-id="element-77" data-mp="823ssbnpo71o">
            {stat}
          </li>)}
      </ul>

      <ol className="mt-10 grid grid-cols-1 gap-4 sm:mt-12 sm:grid-cols-2" data-id="element-78" data-mp="mx9yexiwa3uh">
        {resources.map((resource, index) => <li key={resource.title} className="flex h-full gap-4 rounded-xl bg-white p-4 shadow-[0_18px_30px_-28px_rgba(27,51,64,0.5)] sm:gap-5 sm:p-5" data-id="element-79" data-mp="roibc3jfo7ce" data-mpi={index}>
            <img src={resource.cover} alt={`Portada de ${resource.label}`} className="h-[132px] w-[99px] shrink-0 rounded-[3px] object-cover object-top shadow-[0_10px_18px_-12px_rgba(27,51,64,0.55)] sm:h-[152px] sm:w-[114px]" loading={index > 1 ? 'lazy' : undefined} data-id="element-80" data-mp="3qhdsbzk5sv49" />
            <div className="flex min-w-0 flex-1 flex-col" data-id="element-81" data-mp="3vf5tzlalvvln">
              <p className="font-sans text-[9.5px] font-medium uppercase tracking-[0.16em] text-caribe" data-id="element-82" data-mp="dzpf6tiudufr">
                {String(index + 1).padStart(2, '0')} · {resource.label}
              </p>
              <h3 className="mt-2 font-display text-[19px] font-bold leading-tight text-oceano sm:text-[21px]" data-id="element-83" data-mp="n0f37b1v2gix">
                {resource.title}
              </h3>
              <p className="mt-2 font-sans text-[12px] leading-relaxed text-hierro sm:text-[12.5px]" data-id="element-84" data-mp="i1u6vmpqcgzr">
                {resource.description}
              </p>
            </div>
          </li>)}
      </ol>
    </Section>;
}